module.exports = __webpack_public_path__ + "img/icon_文件列表_空白@3x.8108ae62.png";